import { UndoIcon, RedoIcon, HomeIcon, ExportIcon, SaveIcon, ShareIcon } from './icons';

const Menu = ({
  handleUndo = () => {},
  handleRedo = () => {},
  isDarkMode,
  canUndo = () => false,
  canRedo = () => false,
  showHome,
  onHome,
  onExport,
  onExportData,
  onShare,
  onMapFont,
  canWrite = true,
}) => {

    const buttonStyle = {
        background: 'transparent',
        border: 'none',
        padding: 2,
        marginBottom: 8,
        minWidth: 40,
        minHeight: 40,

        cursor: 'pointer',
        color: isDarkMode ? '#fff' : '#000',
        fontSize: 19,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
    return (
        <div role="toolbar" aria-label="Map actions"
          style={{
            backgroundColor: isDarkMode
              ? 'rgba(45, 45, 45, 0.7)'
              : 'rgba(255, 255, 255, 0.7)',
            borderRadius: 15,
            padding: 10,
          }}
          onClick={(e) => e.stopPropagation()}
          onPointerDown={(e) => e.stopPropagation()}
          onPointerUp={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
        >
        {showHome && onHome && (
          <button aria-label="Show whole map" title="Show whole map" onClick={onHome} style={{ ...buttonStyle, marginTop: 20 }}>
            <HomeIcon />
          </button>
        )}
        <button
          onClick={handleUndo}
          disabled={!canWrite || !canUndo()}
          style={buttonStyle}
          title="Undo (Ctrl/Cmd+Z)"
          aria-label="Undo"
        >
          <UndoIcon />
        </button>
        <button
          onClick={handleRedo}
          disabled={!canWrite || !canRedo()}
          style={buttonStyle}
          title="Redo (Ctrl/Cmd+Shift+Z)"
          aria-label="Redo"
        >
          <RedoIcon />
        </button>
        {onMapFont && <button type="button" onClick={onMapFont} style={buttonStyle} title="Map font" aria-label="Map font"><span aria-hidden="true">Aa</span></button>}
        {onExport && (
          <button onClick={onExport} style={buttonStyle} title="Export as PNG image">
            <ExportIcon />
          </button>
        )}
        {onExportData && (
          <button
            onClick={onExportData}
            style={buttonStyle}
            title="Export map as JSON"
            aria-label="Export map"
          >
            <SaveIcon />
          </button>
        )}
        {onShare && (
          <button
            onClick={onShare}
            style={buttonStyle}
            title="Share map"
            aria-label="Share map"
          >
            <ShareIcon />
          </button>
        )}
        </div>
        )

}

export default Menu;
